/**
 * Marqueurs d'état de la synthèse — EF-RBK-008, EF-CAL-005, EF-POI-012.
 * Ils restent visibles en permanence tant qu'ils s'appliquent.
 */

import type { JSX } from 'preact';
import type { RoadbookDocument } from '../../core/model';
import { MARKERS } from '../labels';
import { Glyph } from '../icons';

export interface MarkerListProps {
  readonly document: RoadbookDocument;
  readonly stale: boolean;
  readonly compact?: boolean;
}

export function MarkerList(props: MarkerListProps): JSX.Element | null {
  const { document, stale } = props;
  const integrity = document.results.searchIntegrity;
  const track = document.route.track;
  const flags = document.results.flags;

  const entries: string[] = [];
  if (stale || flags.needsRecalculation) entries.push(MARKERS.staleValues);
  if (integrity.missingRanges.length > 0) {
    entries.push(`${MARKERS.partialResult} : ${integrity.missingChunkCount} tronçon(s) manquant(s)`);
  }
  if (integrity.parameterSets.length > 1) entries.push(MARKERS.heterogeneousParameters);
  if (flags.sleepSkippedByUser) entries.push(MARKERS.noSleep);
  if (!track.elevation.available) entries.push(MARKERS.elevationUnavailable);
  if (track.segmentGaps.length > 0) {
    entries.push(`${MARKERS.segmentGaps} : ${track.segmentGaps.length}`);
  }
  if (track.pointAnomalies.length > 0) {
    entries.push(`${MARKERS.pointAnomalies} : ${track.pointAnomalies.length}`);
  }
  if (flags.timezoneWarning) entries.push(MARKERS.timezone);

  if (entries.length === 0) return null;

  return (
    <div class="markers">
      {entries.map((entry) => (
        <p class="marker" key={entry}>
          <Glyph name="zone" label="Avertissement" size={20} />
          <span>{entry}</span>
        </p>
      ))}
    </div>
  );
}
